// extracted by mini-css-extract-plugin
module.exports = {"wrap":"improve-content_wrap__G1g2U","checkBox":"improve-content_checkBox__1UPi9","input":"improve-content_input__2pFRu","active":"improve-content_active__3WEGO"};